// extracted by mini-css-extract-plugin
module.exports = {"xsVisible":"_button_square-module--xs-visible--1OxXT","xsHidden":"_button_square-module--xs-hidden--3kswd","oButtonSquare":"_button_square-module--o-button-square--1tyAC"};